@if (isLoading()) {
  @if (loadingTemplate()) {
    <ng-container *ngTemplateOutlet="loadingTemplate()!"></ng-container>
  }
} @else {
  <div #wrapper class="flex h-full max-h-screen w-full box-border p-4">
    <div
      #leftArea
      class="order-1 h-full"
      [style.min-width.%]="minLeftAreaWidthPercent()"
      [style.max-width.%]="maxLeftAreaWidthPercent()"
    >
      <ng-container *ngTemplateOutlet="leftAreaTemplate()"></ng-container>
    </div>

    <div
      #separator
      class="order-2 flex flex-col h-full items-center justify-center"
    >
      <button
        (mousedown)="onDragStarted()"
        (dblclick)="onDragIconDoubleClick()"
        [disabled]="isDragDisabled()"
        mat-icon-button
        class="!cursor-ew-resize"
      >
        <mat-icon fontIcon="drag_indicator"></mat-icon>
      </button>
    </div>

    <div
      #rightArea
      class="order-3 flex flex-shrink flex-grow h-full rounded-xl p-4 outline outline-1 outline-secondary-variant"
    >
      <ng-container *ngTemplateOutlet="rightAreaTemplate()"></ng-container>
    </div>
  </div>
}
